import { Notifications } from './Notifications';

/**
 * Dock-компонент уведомлений.
 * Использует Notifications из этого же модуля.
 */
export function NotificationsDockPanel() {
  return <Notifications isModal />;
}
